import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientBeneficiarySavePepMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SavePepConnectionParam } from 'api/types/params';

import { parseClientPepConnectionParam } from '../../helpers';

import { parseLegalClientBeneficiaryEntity } from './helpers';

export const useLegalClientBeneficiarySavePep = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBeneficiarySavePepMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientBeneficiarySavePep
      ? parseLegalClientBeneficiaryEntity(data.legalClientBeneficiarySavePep)
      : undefined,
    loading,
    error,
    savePepConnection: useCallback(
      async (
        id: string,
        beneficiaryId: string,
        params: SavePepConnectionParam
      ) => {
        const input = parseClientPepConnectionParam(params);
        const res = await handle({
          variables: {
            id,
            beneficiaryId,
            input,
          },
        });
        return res?.data?.legalClientBeneficiarySavePep
          ? parseLegalClientBeneficiaryEntity(
              res.data.legalClientBeneficiarySavePep
            )
          : undefined;
      },
      [handle]
    ),
  };
};
